import {
  MaterialUICore,
  axiomTokens,
  Button as DSButton,
  Box as DSBox,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { color, spacing } = axiomTokens;

export const Button = styled(DSButton)({
  color: color.interactive.accent.default,
});

export const Box = styled(DSBox)({
  gap: spacing[4],
});
